import React from 'react'
import { useTrans } from 'hooks'
import { ClienteNode, LocalitaNode, PaginaNode } from '@gql/graphql'
import { GenericHero, Page, Prefooter, RivenditoriList, RivenditoriMap } from 'components/organisms'
import styles from './RivenditoriTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
  rivenditori?: ClienteNode[]
  items?: LocalitaNode[]
  variant?: 'default' | 'regione' | 'provincia' | 'citta'
  localita?: LocalitaNode
}

const RivenditoriTemplate = (props: Props) => {
  const { pagina = undefined, rivenditori = [], items = [], variant = 'default', localita } = props

  const t = useTrans()

  const title =
    variant === 'default'
      ? t('Cerca per regione')
      : variant === 'regione'
      ? t('Cerca per provincia')
      : variant === 'provincia'
      ? t('Cerca per città')
      : null
  const breadcrumbs = pagina.breadcrumbs.concat(
    variant === 'regione'
      ? [{ label: localita.name }]
      : variant === 'provincia'
      ? [
          {
            label: localita.clienteRef?.regioneDummy,
            url: `${pagina.url}/${localita.clienteRef.regioneSlug}/`,
          },
          { label: localita.name },
        ]
      : variant === 'citta'
      ? [
          {
            label: localita.clienteRef?.regioneDummy,
            url: `${pagina.url}/${localita.clienteRef.regioneSlug}/`,
          },
          {
            label: localita.clienteRef?.provinciaDummy,
            url: `${pagina.url}/${localita.clienteRef.regioneSlug}/${localita.clienteRef.provinciaSlug}/`,
          },
          { label: localita.name },
        ]
      : []
  )

  const rivenditoriFiltered =
    variant === 'default' || !localita
      ? []
      : rivenditori.filter((x) => {
          switch (variant) {
            case 'regione':
              return x.regioneSlug === localita.slug
            case 'provincia':
              return x.provinciaSlug === localita.slug
            case 'citta':
              return x.cittaSlug === localita.slug
            default:
              return false
          }
        })

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <GenericHero
          pagina={
            variant === 'default'
              ? pagina
              : {
                  titolo: localita ? t('{0}: {1}', [pagina.titolo, localita.name]) : pagina.titolo,
                  breadcrumbs: breadcrumbs,
                }
          }
        />
        <RivenditoriMap rivenditori={rivenditori} rivenditoriFiltered={rivenditoriFiltered} />
        {title && <RivenditoriList title={title} items={items} />}
        <Prefooter skipRivenditore />
      </main>
    </Page>
  )
}

export default RivenditoriTemplate
